<template>
  <div id="livingCode">
    <tabtop></tabtop>
    <div class="livingCode1"><img :src="url+banner.images[0]" alt=""  @click="jumpbannerpage(banner.url,0)"></div> 
    <div class="liveingCode2">
        <p class="title">智能分流、精准营销</p>
        <ul>
            <li v-for="(item,index) in liveingCode2" :key="index" :class="[liveingCode2Index==index?'on':'','wow','animate__animated','animate__fadeIn']" @mouseover="liveingCode2Index=index">
                <img :src="item.img_on" alt="" v-show="liveingCode2Index!=index">
                <img :src="item.img" v-show="liveingCode2Index==index">
                <p class="p1" v-html="item.title"></p>
                <p class="p2" v-html="item.subtitle"></p>
            </li>
        </ul>
    </div>
    <div class="liveingCode3">
        <p class="title">活码应用场景</p>
        <ul>
            <li v-for="(item,index) in liveingCode3" :key="index" :class="[index%2!=0?'list':'','wow','animate__animated','animate__fadeIn']">
                <div class="listBg">
                    <div>
                        <img :src="item.img" alt="">
                    </div>
                    <div>
                        <p class="p1">{{item.title}}<span>0{{index+1}}</span></p>
                        <p class="p2">{{item.subtitle}}</p>
                        <p class="p3">{{item.content}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="liveingCode4" id="liveingCode4">
        <p class="title">活码核心功能</p>
        <ul>
            <li v-for="(item,index) in liveingCode4" :key="index" class="wow animate__animated animate__fadeIn">
                <p class="p1">{{item.title}}</p>
                <p class="p2">{{item.subtitle}}</p>
            </li>
        </ul>
    </div>
    <webbottom></webbottom>
  </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    components: {
        tabtop,
        webbottom
    },
    data(){
        return{
            url : window.url,
            banner:{},
            liveingCode2Index:1,
            liveingCode2:[
                {
                    img:require("@/assets/product/livingCode2img1.png"),
                    img_on:require("@/assets/product/livingCode2img1.png"),
                    title:"智能分流<br/>高效转化加粉",
                    subtitle:"不限量设置分<br/>推荐用户去最合适的群"
                },
                {
                    img:require("@/assets/product/livingCode2img2on.png"),
                    img_on:require("@/assets/product/livingCode2img2on.png"),
                    title:"智能分流<br/>高效转化加粉",
                    subtitle:"不限量设置分<br/>推荐用户去最合适的群"
                },
                {
                    img:require("@/assets/product/livingCode2img3.png"),
                    img_on:require("@/assets/product/livingCode2img3.png"),
                    title:"智能分流<br/>高效转化加粉",
                    subtitle:"不限量设置分<br/>推荐用户去最合适的群"
                },
            ],
            liveingCode3:[
                {
                    img:require("@/assets/product/livingCode3img1.png"),
                    title:"私域引流活码",
                    subtitle:"群二维码永久有效，满200人自动切换",
                    content:"社群引流，可随时切换群二维码，且二维码不变，永久有效"
                },
                {
                    img:require("@/assets/product/livingCode3img2.png"),
                    title:"个人裂变活码",
                    subtitle:"个人号引流、直播、营销",
                    content:"个人号仅需一个二维码推广，达到限制自动切换，分组分标签引流"
                },
                {
                    img:require("@/assets/product/livingCode3img3.png"),
                    title:"线下裂变活码",
                    subtitle:"裂变海报、传单、卡片",
                    content:"二维码可随时配置，永久有效，二维码不用换。"
                },
                {
                    img:require("@/assets/product/livingCode3img4.png"),
                    title:"分组裂变活码",
                    subtitle:"自定义活动图，选择性入群",
                    content:"用户扫码后可自行选择群组，统一入口有效分销，精准营销。"
                }
            ],
            liveingCode4:[
                {
                    title:"活码分渠道",
                    subtitle:"可自由配置活码渠道随时切换活码"
                },
                {
                    title:"活码分组标签",
                    subtitle:"机型/地区/城市多类型活码标签配置"
                },
                {
                    title:"活码数据分析",
                    subtitle:"实现多维度实时效果追踪"
                },
                {
                    title:"活码安全无忧",
                    subtitle:"专业防红，安全稳定使用无忧"
                }
            ]
        }
    },
    mounted(){
        that = this
        rotationmap({'type':8}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            this.$nextTick(function(){
                                if(this.$route.query.id){
                    document.getElementById(this.$route.query.id).scrollIntoView();
                }
                //初始化动画
                this.$wow.init()
            })
        })
        
    },
    methods:{
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #livingCode{
        .livingCode1{
            img{
                width: 100%;
            }
        }
        .liveingCode2{
            width: 1400px;
            margin:60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 60px;
                li{
                    width: 400px;
                    background: #F9F8F8;
                    border-radius: 16px 16px 16px 16px;
                    text-align: center;
                    padding: 30px;
                    img{
                        width: 130px;
                    }
                    .p1{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #666666;
                        margin-top: 20px;
                    }
                    .p2{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #333333;
                        margin-top: 30px;
                    }
                }
                .on{
                    background: linear-gradient(135deg, #1ECCD0 5%, #A1FBFF 100%);
                    border-radius: 16px 16px 16px 16px;
                    .p1{
                        color: #FFFFFF;
                    }
                    .p2{
                        color: #FFFFFF;
                    }
                }
            }
        }
        .liveingCode3{
            margin:60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
                margin-bottom: 20px;
            }
            ul{
                li{
                    background: #F6FAFF;
                    .listBg{
                        width: 1300px;
                        margin:0 auto;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        // padding: 50px 0;
                        img{
                            width: 600px;
                            margin-right: 50px;
                        }
                        .p1{
                            font-size: var(--web-title-fontsize);
                            font-weight: normal;
                            color: #558AFF;
                            position: relative;
                            display: inline-block;
                            padding-left: 60px;
                            span{
                                position: absolute;
                                font-size: 100px;
                                font-weight: normal;
                                color: #EBEDFF;
                                top: 50%;
                                left: 0%;
                                transform: translateY(-50%);
                                z-index: -1;
                            }
                        }
                        .p2{
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: normal;
                            color: #333333;
                            margin-top: 20px;
                        }
                        .p3{
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: normal;
                            color: #333333;
                            margin-top: 30px;
                            width: 600px;
                        }
                        div{
                            padding: 80px 0;
                        }
                    }
                }
                .list{
                    background: #fff;
                    .listBg{
                        flex-direction:row-reverse;
                        img{
                            margin-right: 0;
                            margin-left: 50px;
                        }
                    }
                }
            }
        }
        .liveingCode4{
            margin:60px auto 20px;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                width: 1300px;
                margin:0 auto;
                display: flex;
                justify-content: space-between;
                margin-top: 100px;
                li{
                    width: 300px;
                    border-radius: 48px 48px 48px 48px;
                    padding: 90px 29px 62px 29px;
                    .p1{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #FFFFFF;
                        margin-bottom: 30px;
                    }
                    .p2{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #FFFFFF;
                    }
                }
                li:hover{
                    transform: translateY(-20px);
                }
                li:nth-child(1){
                    background: linear-gradient(136deg, #30B3B6 0%, #65E1E6 100%);
                }
                li:nth-child(2){
                    background: linear-gradient(138deg, #3B58E0 0%, #8499F8 100%);
                }
                li:nth-child(3){
                    background: linear-gradient(137deg, #F3760C 0%, #FFB06D 100%);
                }
                li:nth-child(4){
                    background: linear-gradient(136deg, #2CBB2C 0%, #8BF18C 100%);
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #livingCode{
        .livingCode1{
            img{
                width: 100%;
            }
        }
        .liveingCode2{
            width: 100%;
            margin:1.875rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin: 1.25rem 0.625rem;
                li{
                    flex:0 0 30%;
                    background: #F9F8F8;
                    border-radius: 1rem 1rem 1rem 1rem;
                    text-align: center;
                    padding: 0.625rem;
                    img{
                        width: 1.875rem;
                    }
                    .p1{
                        font-size: 0.875rem;
                        font-weight: normal;
                        color: #666666;
                        margin-top: 0.625rem;
                    }
                    .p2{
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #333333;
                        margin-top: 0.625rem;
                    }
                }
                .on{
                    background: linear-gradient(135deg, #1ECCD0 5%, #A1FBFF 100%);
                    border-radius: 1rem 1rem 1rem 1rem;
                    .p1{
                        color: #FFFFFF;
                    }
                    .p2{
                        color: #FFFFFF;
                    }
                }
            }
        }
        .liveingCode3{
            width: 100%;
            margin:3.75rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
                margin-bottom: 0.625rem;
            }
            ul{
                li{
                    background: #F6FAFF;
                    .listBg{
                        width: 100%;
                        margin:0 auto;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        // padding: 3.125rem 0;
                        flex-wrap: wrap;
                        img{
                            width: 100%;
                        }
                        .p1{
                            width: 100%;
                            font-size: 1.25rem;
                            font-weight: normal;
                            color: #558AFF;
                            position: relative;
                            display: inline-block;
                            padding-left: 3.125rem;
                            span{
                                position: absolute;
                                font-size: 2.5rem;
                                font-weight: normal;
                                color: #EBEDFF;
                                top: 50%;
                                left: 00%;
                                transform: translateY(-50%);
                                z-index: 10;
                            }
                        }
                        .p2{
                            width: 100%;
                            font-size: 1rem;
                            font-weight: normal;
                            color: #333333;
                            margin-top: 0.625rem;
                        }
                        .p3{
                            width: 100%;
                            font-size: 0.75rem;
                            font-weight: normal;
                            color: #333333;
                            margin-top: 0.625rem;
                        }
                        div{
                            width: 100%;
                            padding: 1.25rem 1.25rem;
                        }
                    }
                }
            }
        }
        .liveingCode4{
            width: 100%;
            margin:1.25rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                width: 95%;
                margin:0 auto;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin:1.25rem 0.625rem;
                li{
                    flex: 0 0 45%;
                    border-radius: 1.25rem;
                    padding: 1.25rem;
                    margin-bottom: 0.625rem;
                    .p1{
                        font-size: 1rem;
                        font-weight: normal;
                        color: #FFFFFF;
                        margin-bottom: 0.625rem;
                    }
                    .p2{
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #FFFFFF;
                    }
                }
                li:hover{
                    transform: translateY(-1.25rem);
                }
                li:nth-child(1){
                    background: linear-gradient(136deg, #30B3B6 0%, #65E1E6 100%);
                }
                li:nth-child(2){
                    background: linear-gradient(138deg, #3B58E0 0%, #8499F8 100%);
                }
                li:nth-child(3){
                    background: linear-gradient(137deg, #F3760C 0%, #FFB06D 100%);
                }
                li:nth-child(4){
                    background: linear-gradient(136deg, #2CBB2C 0%, #8BF18C 100%);
                }
            }
        }
    }
 
}
</style>